/* SOYUL v15 — progressive variant controls and Shopify-managed cookie consent. */
(() => {
  'use strict';
  const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL'];
  function initVariants(scope = document) {
    scope.querySelectorAll('[data-soyul-product]').forEach(root => {
      // The PDP purchase controller owns selection and button state.
      // Never hydrate a first variant behind its explicit size choice.
      if (root.matches('.soyul-pdp')) return;
      if (root.dataset.variantsReady) return;
      const select = root.querySelector('[data-soyul-variant-id]');
      const data = root.querySelector('[data-soyul-variants]');
      if (!select || !data) return;
      let config;
      try { config = JSON.parse(data.textContent); } catch { return; }
      const variants = config.variants;
      if (!variants?.length) return;
      root.dataset.variantsReady = 'true';
      let names = config.names;
      let options = variants.map(v => v.options);
      // Only split a legacy combined option if every real variant has an unambiguous size prefix.
      const split = variants.map(v => v.title.match(/^(XXS|XS|S|M|L|XL|XXL|2XL|3XL|4XL)\s*(?:\/|–|—|-)\s*(.+)$/i));
      if (names.length === 1 && split.every(Boolean)) {
        names = ['Taille', 'Coloris'];
        options = split.map(m => [m[1].toUpperCase(), m[2]]);
      }
      let selectedIndex = variants.findIndex(v => String(v.id) === select.value);
      if (selectedIndex < 0) selectedIndex = 0;
      let chosen = [...options[selectedIndex]];
      const groups = root.querySelector('[data-soyul-variant-groups]');
      const controls = root.querySelector('[data-soyul-variant-controls]');
      const price = root.querySelector('[data-soyul-price]');
      const buttons = [];
      function update(index, updateUrl = false) {
        const variant = variants[index];
        select.value = variant ? String(variant.id) : '';
        const submit = root.querySelector('[ref="addToCartButton"]');
        if (submit) {
          submit.disabled = !variant?.available;
          const text = submit.querySelector('.add-to-cart-text__content span span');
          if (text) text.textContent = !variant ? 'Combinaison indisponible' : variant.available ? 'Ajouter au panier' : 'Épuisé';
        }
        if (price) {
          const template = variant && root.querySelector(`[data-soyul-variant-price="${variant.id}"]`);
          if (template) price.replaceChildren(template.content.cloneNode(true));
          else price.textContent = 'Cette combinaison n’est pas proposée.';
        }
        buttons.forEach(({ button, value, axis }) => {
          const active = chosen[axis] === value;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', String(active));
          const inStock = variants.some((v, i) => v.available && options[i].every((o, j) => o === (j === axis ? value : chosen[j])));
          button.classList.toggle('is-unavailable', !inStock);
          button.setAttribute('aria-label', `${names[axis]} : ${value}${inStock ? '' : ' — combinaison indisponible'}`);
        });
        // The native product component reads ?variant= before its form field. Keep both synchronized.
        if (updateUrl) {
          const url = new URL(location.href);
          if (variant) url.searchParams.set('variant', String(variant.id));
          else url.searchParams.delete('variant');
          history.replaceState(history.state, '', url);
        }
        root.dispatchEvent(new CustomEvent('soyul:variant-change', { detail: { variant: variant || null } }));
      }
      if (groups && controls) {
        names.forEach((name, axis) => {
          const fieldset = document.createElement('fieldset');
          const legend = document.createElement('legend');
          legend.textContent = name;
          fieldset.append(legend);
          const grid = document.createElement('div');
          grid.className = 'soyul-product__variant-grid';
          const values = [...new Set(options.map(o => o[axis]))];
          if (values.every(value => sizeOrder.includes(value.toUpperCase()))) {
            values.sort((a, b) => sizeOrder.indexOf(a.toUpperCase()) - sizeOrder.indexOf(b.toUpperCase()));
          }
          values.forEach(value => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'soyul-product__variant';
            button.textContent = value;
            button.addEventListener('click', () => {
              chosen[axis] = value;
              const index = options.findIndex(option => option.every((v, i) => v === chosen[i]));
              update(index, true);
            });
            buttons.push({ button, axis, value });
            grid.append(button);
          });
          fieldset.append(grid);
          groups.append(fieldset);
        });
        controls.hidden = false;
        select.closest('.soyul-native-variant').hidden = true;
        const heading = controls.querySelector('.soyul-product__variant-head > span');
        if (heading) heading.textContent = 'Choisissez votre pièce';
      } else if (variants.length === 1) {
        select.closest('.soyul-native-variant').hidden = true;
      }
      select.addEventListener('change', () => {
        const index = variants.findIndex(v => String(v.id) === select.value);
        if (index >= 0) chosen = [...options[index]];
        update(index, true);
      });
      update(selectedIndex);
    });
  }
  initVariants();
  document.addEventListener('shopify:section:load', event => initVariants(event.target));

  const dialog = document.querySelector('#SoyulCookiePreferences');
  if (!dialog) return;
  const fields = dialog.querySelector('[data-soyul-cookie-fields]');
  const status = dialog.querySelector('[data-soyul-cookie-status]');
  const retry = dialog.querySelector('[data-soyul-cookie-retry]');
  let returnFocus;
  let requestId = 0;
  let timer;
  const fail = () => {
    fields.disabled = true;
    status.textContent = 'Le service de préférences est indisponible. Aucun choix n’a été confirmé. Réessayez dans un instant.';
    retry.hidden = false;
  };
  function loadConsent() {
    const id = ++requestId;
    clearTimeout(timer);
    fields.disabled = true;
    retry.hidden = true;
    status.textContent = 'Chargement de vos préférences…';
    timer = setTimeout(() => { if (id === requestId) { requestId++; fail(); } }, 12000);
    const ready = error => {
      if (id !== requestId) return;
      clearTimeout(timer);
      const api = window.Shopify?.customerPrivacy;
      if (error || !api?.currentVisitorConsent || !api?.setTrackingConsent) { fail(); return; }
      try {
        const consent = api.currentVisitorConsent();
        fields.querySelectorAll('input').forEach(input => { input.checked = consent[input.name] === 'yes'; });
        fields.disabled = false;
        status.textContent = '';
      } catch { fail(); }
    };
    if (window.Shopify?.customerPrivacy) ready();
    else if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], ready);
    } else { clearTimeout(timer); fail(); }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-soyul-cookie-open]');
    if (!trigger) return;
    returnFocus = trigger;
    dialog.showModal();
    loadConsent();
  });
  dialog.querySelector('[data-soyul-cookie-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { requestId++; clearTimeout(timer); returnFocus?.focus(); });
  retry.addEventListener('click', loadConsent);
  dialog.querySelectorAll('[data-soyul-cookie-action]').forEach(button => {
    button.addEventListener('click', () => {
      const consent = {};
      fields.querySelectorAll('input').forEach(input => {
        consent[input.name] = button.dataset.soyulCookieAction === 'save' ? input.checked : button.dataset.soyulCookieAction === 'accept';
      });
      fields.disabled = true;
      status.textContent = 'Enregistrement…';
      const id = ++requestId;
      timer = setTimeout(() => { if (id === requestId) { requestId++; fail(); } }, 12000);
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(consent, result => {
          if (id !== requestId) return;
          clearTimeout(timer);
          if (result?.error) { fail(); return; }
          const actual = window.Shopify.customerPrivacy.currentVisitorConsent();
          if (!Object.keys(consent).every(key => actual[key] === (consent[key] ? 'yes' : 'no'))) { fail(); return; }
          fields.querySelectorAll('input').forEach(input => { input.checked = consent[input.name]; });
          fields.disabled = false;
          status.textContent = 'Vos préférences ont été enregistrées.';
        });
      } catch { clearTimeout(timer); fail(); }
    });
  });
})();
